import React from 'react';
import VagaForm from '../components/VagaForm';

export default function VagasPage({ user }) {
  return (
    <div>
      {user && <VagaForm user={user} />}
    </div>
  );
}
